import './profile.scss';
import VideoPlayer from '../../shared/video-player/video-player';
import { Context } from '../../../context';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useContext, useEffect, useState } from 'react';
import './profile.scss';
import allBadges from '../../shared/badges/allBadges';
import logoutFetch from '../../../assets/helpers/logoutFetch';
import AddHome from '../../../assets/handouts/addToHome_ezParent.pdf';
import AddHomeEspanol from '../../../assets/handouts/addToHome_espanol.pdf';
import useStore from '../../../customHooks/useStore';
import EulaLink from '../../shared/EulaLink';
import ParentCertificate from '../../course/Overview/ParentCertificate';
import ParentProgressReport from './ParentProgressReport';
import ParentNameEditor from './ParentNameEditor';
function ProfilePage() {
  const context = useContext(Context);
  const [parentName, setParentName] = useState(
    () => localStorage.getItem('name')?.trim() || '',
  );
  const [completedBadges, setCompletedBadges] = useState([]);
  const [completedCert, setCompletedCert] = useState();
  const { language } = useStore((state) => ({
    language: state.language,
    setLanguage: state.setLanguage,
  }));

  const handleBadgeGet = async () => {
    try {
      let data = await fetch(process.env.REACT_APP_API_URL + `/api/badge`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (data.ok) {
        let response = await data.json();
        setCompletedBadges(response);
      } else {
        const errorMessage = await data.text();
        throw new Error(errorMessage);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    context.setSidebarModuleOpen(0);
    handleBadgeGet();
  }, []);

  useEffect(() => {
    if (completedBadges) {
      const haveAllBadges = allBadges
        .filter((item) => item.type === 'module')
        .every((item) => completedBadges.includes(item.badgeName));
      setCompletedCert(haveAllBadges);
    }
  }, [completedBadges]);

  return (
    <section className='slide-wrap' id={'fade'}>
      <h1 className='title'>Profile</h1>
      <div className='video-parent'>
        <div className='video-wrap'>
          <VideoPlayer
            source={{
              en: 749604203,
              es: 1024896020,
            }}
          />
        </div>
      </div>
      <div className='z-card-gray'>
        <div className='buttonWrap'>
          <div className='supportWrapper'>
            <Link to={'/reset-password'} className='  supportButton'>
              <p>Reset Password</p>
            </Link>
          </div>
          <a
            href={AddHome}
            target={'_blank'}
            className={'btn-1 add-home'}
            rel='noreferrer'
          >
            Add to Homescreen
          </a>
          <Link
            to={'/login'}
            className='btn-1 log-out'
            onClick={() => {
              logoutFetch();
              context.logout();
            }}
          >
            Log Out
          </Link>
          <ParentCertificate
            language={language}
            parentName={parentName || 'Parent'}
            compact
            disabled={!completedCert}
            completedAt={new Date().toISOString()}
            facilitatorNames={[]}
            className={`btn-1 download-cert ${
              !completedCert ? 'not-complete' : ''
            }`}
          />
          <ParentProgressReport parentName={parentName || 'Parent'} />
          <section className='extra-links'>
            <a
              href={
                language === 'en'
                  ? './privacy-policy.pdf'
                  : './privacy-policy_Spanish.pdf'
              }
              target='_blank'
              rel='noreferrer'
            >
              Privacy Policy
            </a>
            <EulaLink />
          </section>
        </div>
      </div>
      <ParentNameEditor name={parentName} onNameChange={setParentName} />
    </section>
  );
}

export default ProfilePage;
